import HmAjax from './HmAjax';
import UrlManager from './../model/UrlManager';

/**
* This function needs UserStore to be passed as part of the constructor to work. from LoggedInPage
*/
let AttributeManager = function(userStore){
	
	let updateToServer = function(attr_key, attr_value, callback){
		var me = this;
		var success = function(userObj){
			if(userObj){
				userStore.store(userObj);	
			}

			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var failure = function(error){
			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var attrData = {"attr_key":attr_key, "attr_value":attr_value};
		new HmAjax(UrlManager.getUrlForAction("UPDATE_ATTRIBUTE"),attrData).post(success,failure);
	}

	let removeFromServer = function(attr_key, callback){
		var me = this;
		var success = function(userObj){
			if(userObj){
				userStore.store(userObj);	
			}

			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var failure = function(error){
			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var attrData = {"attr_key":attr_key};
		new HmAjax(UrlManager.getUrlForAction("REMOVE_ATTRIBUTE"),attrData).delete(success,failure);
	}

	const checkLength = (attr_key, attr_value) => {
		  let errMsgs = [];
		  let error = false;

		  if(attr_key && attr_key.length > 20){
		  	  error = true;
		  	  errMsgs.push("attr_key cannot be more than 20");
		  }

		  if(attr_value && attr_value.length > 50){
		  	  error = true;
		  	  errMsgs.push("attr_value cannot be more than 50");	  
		  }

		  if(error){
		  	 throw(errMsgs);
		  }
	}

	return {
		update:function(attr_key, attr_value, callback){
			checkLength(attr_key, attr_value);

			updateToServer(attr_key, attr_value, callback);
		},
		remove: function(attr_key, callback){
			removeFromServer(attr_key, callback);
		}
	}
};

export default AttributeManager;


// WEBPACK FOOTER //
// ./src/util/AttributeManager.js